/**
 * EnergyTable - Display energy impact tables per stage
 */

interface EnergyChange {
  role: string;
  condition: string;
  change: string;
  description?: string;
}

interface EnergyTableProps {
  changes: EnergyChange[];
  title?: string;
}

export function EnergyTable({ changes, title }: EnergyTableProps) {
  return (
    <div className="my-4">
      {title && <h4 className="text-sm font-semibold text-[#12356B] mb-2">{title}</h4>}
      <div className="overflow-x-auto">
        <table className="min-w-full border border-[#CED4DE] rounded-lg">
          <thead className="bg-[#E2E5EC]/50">
            <tr>
              <th className="px-4 py-2 text-left text-xs font-semibold text-slate-700 border-b">Role</th>
              <th className="px-4 py-2 text-left text-xs font-semibold text-slate-700 border-b">Condition</th>
              <th className="px-4 py-2 text-left text-xs font-semibold text-slate-700 border-b">Change</th>
              {changes.some((c) => c.description) && (
                <th className="px-4 py-2 text-left text-xs font-semibold text-slate-700 border-b">Description</th>
              )}
            </tr>
          </thead>
          <tbody>
            {changes.map((change, index) => {
              const isPositive = change.change.startsWith('+');
              const isNegative = change.change.startsWith('-');
              const changeColorClass = isPositive
                ? 'text-[#367A25] font-semibold'
                : isNegative
                ? 'text-[#c4562a] font-semibold'
                : 'text-slate-700';

              return (
                <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-[#E2E5EC]/50'}>
                  <td className="px-4 py-2 text-xs text-slate-700 border-b">{change.role}</td>
                  <td className="px-4 py-2 text-xs text-slate-700 border-b">{change.condition}</td>
                  <td className={`px-4 py-2 text-xs border-b ${changeColorClass}`}>{change.change}</td>
                  {changes.some((c) => c.description) && (
                    <td className="px-4 py-2 text-xs text-slate-600 border-b">{change.description || '—'}</td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
